import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import proxy from "proxy";

const initialState = {
    tagGroupsArr: [],
}

export const fetchTagGroups = createAsyncThunk("fetchTagGroups", async (projectId) => {
    const response = await fetch(`${proxy}/tagGroup/get?projectId=${projectId}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json"
        }
    });
    const status = response.status;
    const responseBody = await response.json();
    return { responseBody, status };
});

export const createTagGroup = createAsyncThunk("createTagGroup", async (data) => {
    const response = await fetch(`${proxy}/tagGroup/add`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    const status = response.status;
    const responseBody = await response.json();
    return { status, responseBody };

});

export const updateTagGroup = createAsyncThunk("updateTagGroup", async (data) => {
    const response = await fetch(`${proxy}/tagGroup/update`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })

    const status = response.status;
    const id = data.id;
    const responseBody = await response.json();
    return { status, responseBody, id };
});

export const deleteTagGroup = createAsyncThunk("deleteTagGroup", async (id) => {
    const response = await fetch(`${proxy}/tagGroup/delete`, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ id })
    });
    const status = response.status;
    const responseBody = await response.json();
    return { status, responseBody, id }
})

const tagGroupSlice = createSlice({
    name: "tagGroup",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchTagGroups.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.tagGroupsArr = action.payload.responseBody.data
            }
        });

        builder.addCase(createTagGroup.fulfilled, (state, action) => {
            if (action.payload.status === 201) {
                state.tagGroupsArr.push(action.payload.responseBody.data)
            }
        })

        builder.addCase(updateTagGroup.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                const updateGroupIndex = state.tagGroupsArr.findIndex((group) => group._id === action.payload.id);
                state.tagGroupsArr[updateGroupIndex] = action.payload.responseBody.data
            }
        })

        builder.addCase(deleteTagGroup.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                const filteredTagGroups = state.tagGroupsArr.filter((group) => group._id !== action.payload.id);
                state.tagGroupsArr = filteredTagGroups
            }
        })

    }
});

export default tagGroupSlice.reducer;